import { Link } from 'react-router-dom'
import { Briefcase, Camera, Lock, Share2, Mail, MapPin, Phone } from 'lucide-react'
import { useShop } from '../context/Shop'
import { COMPANY } from '../lib/format'

export default function Footer() {
  const { menu } = useShop()
  const columns = menu.flatMap((e) => e.columns ?? [])
  const link = 'hover:text-white transition-colors'
  return (
    <footer className="bg-navy-950 text-slate-400 text-xs border-t border-slate-800 no-print" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          <div className="lg:col-span-2 space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-brand-ink rounded-lg flex items-center justify-center font-display font-bold text-lg text-white">CS</div>
              <span className="font-display text-xl font-bold text-white tracking-wider">CARPER<span className="text-brand-orange">SPORTS</span></span>
            </div>
            <p className="text-slate-400 text-xs leading-relaxed max-w-sm">Équipementier et distributeur d'articles de sport à destination des associations et clubs sportifs (Football, Handball, Basketball, Volleyball, Pétanque, Running, Athlétisme).</p>
            <div className="flex items-center gap-3 text-slate-300">
              {[Share2, Camera, Briefcase].map((I, i) => <a key={i} href="#" className="p-2 bg-slate-800 rounded-lg hover:text-white transition-colors" aria-label="Réseau social"><I className="w-4 h-4" /></a>)}
            </div>
          </div>
          <div>
            <h4 className="font-bold text-white text-sm mb-3">Nos Disciplines</h4>
            <ul className="space-y-2">
              {columns.map((c) => <li key={c.accent}><Link to={c.to} className={`flex items-center gap-2 ${link}`}><span className="cs-dot" data-accent={c.accent} style={{ background: c.color }} />Équipements {c.title}</Link></li>)}
              <li><Link to="/catalogue?sub=soins" className={`flex items-center gap-2 ${link}`}><span className="cs-dot" />Pharmacie & Soins</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-white text-sm mb-3">Services Clubs</h4>
            <ul className="space-y-2">
              <li><Link to="/inscription" className={`${link} text-brand-orange font-semibold`} data-testid="footer-register-link">Créer un compte</Link></li>
              <li><Link to="/connexion" className={link} data-testid="footer-login-link">Connexion à mon espace</Link></li>
              <li><Link to="/club" className={link}>Boutiques Clubs</Link></li>
              <li><Link to="/services-clubs" className={link} data-testid="footer-services-clubs">Services pour les clubs</Link></li>
              <li><Link to="/catalogues" className={link}>Catalogues Partenaires</Link></li>
              <li><Link to="/devis" className={link}>Demander un Devis Express</Link></li>
              <li><Link to="/cgv" className={link}>Conditions Générales de Vente</Link></li>
              <li><Link to="/mentions-legales" className={link}>Mentions légales</Link></li>
              <li><Link to="/confidentialite" className={link}>Politique de confidentialité</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-white text-sm mb-3">Contact & Support</h4>
            <ul className="space-y-2">
              <li><a href={COMPANY.phoneHref} className="flex items-center gap-2 hover:text-white"><Phone className="w-3.5 h-3.5 text-brand-orange" /> {COMPANY.phone}</a></li>
              <li><a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-white"><Mail className="w-3.5 h-3.5 text-brand-orange" /> {COMPANY.email}</a></li>
              <li className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-brand-orange" /> {COMPANY.city}</li>
              <li className="pt-2 text-[11px] text-slate-400">Service client ouvert du lundi au vendredi (9h-18h)</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-4 text-[11px]">
          <p>© {new Date().getFullYear()} Carper Sports. Tous droits réservés.</p>
          <div className="flex items-center gap-3"><Lock className="w-3.5 h-3.5 text-brand-green" /><span>Paiement sécurisé · CB / Visa / Mastercard · Virement · Mandat administratif</span></div>
        </div>
      </div>
    </footer>
  )
}
